var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReleasesIcon = function SvgReleasesIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24559_70907)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7927 16.1647L15.597 21.9212C15.0665 22.3456 14.3017 22.3033 13.8213 21.8229L10.1757 18.1772C9.69528 17.6968 9.65292 16.932 10.0773 16.4015L15.8339 9.20585C18.4662 5.91547 22.4514 4.00006 26.6652 4.00006C27.4015 4.00006 27.9985 4.59701 27.9985 5.33339C27.9985 9.54713 26.0831 13.5324 22.7927 16.1647Z",
    stroke: "#D1D1D6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3346 17.3334V23.176C21.3346 23.6811 21.0493 24.1427 20.5976 24.3686L17.3764 25.9793C16.7177 26.3086 15.9168 26.0416 15.5875 25.383C15.5593 25.3265 15.5351 25.2682 15.5152 25.2083L14.668 22.6667",
    stroke: "#D1D1D6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33251 17.3333L6.79096 16.4862C6.09237 16.2533 5.71483 15.4982 5.94769 14.7996C5.96764 14.7398 5.99181 14.6814 6.02003 14.625L7.63069 11.4037C7.85653 10.9521 8.31818 10.6667 8.82317 10.6667H14.6658",
    stroke: "#D1D1D6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.6668 27.4492L4 28.0001L4.55087 24.3333C4.72957 23.1437 5.66334 22.21 6.85285 22.0313C8.34896 21.8065 9.74404 22.8371 9.96885 24.3332C10.0094 24.603 10.0094 24.8774 9.96885 25.1473C9.79012 26.3368 8.85632 27.2705 7.6668 27.4492Z",
    stroke: "#D1D1D6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24559_70907"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
};
export { SvgReleasesIcon as ReactComponent };
export default __webpack_public_path__ + "releases-icon.svg";